import PropTypes from "prop-types";
import React from "react";
import Button from "../../../Button/Button";
import { useHistory } from "react-router-dom";

const Approved = (props) => {
  const { showAlert, setShowAlert, type, userType, appId, bankCode, wsdlUrl, acctNumber} = props;

  const history = useHistory();

  const viewPublicKeys = () => {
    history.push({
      pathname: "/nip/credentials",
      state: {
        bankCode: bankCode,
        wsdlUrl: wsdlUrl,
        acctNumber: acctNumber
      },
    });
  };

  const goToTestPage = () => {
    if (type === "inward_integration") {
      history.push({
        pathname: "/nip/integration/test/inward",
        state: { appId: appId, type: type },
      });
    } else {
      history.push({
        pathname: "/nip/integration/test/outward",
        state: { appId: appId, type: type },
      });
    }
  };

  return (
    <div>
      {showAlert && (
        <div className="nip-public-keys-alert3">
          <div className="text3">
            Your NIP Integration application has been approved and your public
            keys and credentials has been sent
          </div>
          <div className="left-sec">
            <div
              className="link"
              data-testid="viewkeys"
              onClick={() => viewPublicKeys()}
            >
              VIEW BANK CODE
            </div>
            <div
              className="close3"
              data-testid="close3"
              onClick={() => setShowAlert(false)}
            >
              X
            </div>
          </div>
        </div>
      )}

      <div className="update-app">
        <div className="text">
          You have been granted access to run integration test
        </div>
        <Button
          className="button"
          type="submit"
          width="150px"
          height="50px"
          text="PROCEED"
          testId="goToTestPage"
          disabled={userType !== "company"}
          onClick={() => goToTestPage()}
        />
      </div>
    </div>
  );
};

Approved.propTypes = {
  acctNumber: PropTypes.any,
  appId: PropTypes.any,
  bankCode: PropTypes.any,
  publicKey: PropTypes.any,
  setShowAlert: PropTypes.func,
  showAlert: PropTypes.any,
  type: PropTypes.string,
  userType: PropTypes.string,
  wsdlUrl: PropTypes.any
}

export default Approved;
